import React, { useEffect, useRef } from "react";
import AddressFileds from "../entities/address/AddressFileds";
import { useDispatch } from "react-redux";
import { fetchCities, fetchStates } from "../entities/address/addressesSlice";
import PropTypes from "prop-types";

const ShareholderAddress = ({
  addressData,
  setAddressData,
  setBtnToggle,
  type,
  isNewAddress,
  isEdit,
  isLoading = false,
}) => {
  const dispatch = useDispatch();
  const hasFetchedDropdownData = useRef(false);

  const handleOnchange = async (e) => {
    const { name, value } = e.target;
    setAddressData((prev) => ({ ...prev, [name]: value }));
    if (name === "country") {
      const countryCode = value.code;
      const stateRes = await dispatch(fetchStates(countryCode)).unwrap();
      const stateOptions = stateRes.map((state) => ({
        name: state.label,
        code: state.value,
      }));
      setAddressData((prev) => ({
        ...prev,
        state: null,
        city: null,
        stateOptions,
        cityOptions: [],
        country: value,
      }));
    }
    if (name === "state") {
      //   const item = regAddData.find((item) => item.id === id);
      const countryCode = addressData?.country?.code || addressData?.country;
      const stateCode = value.code;

      if (countryCode && stateCode) {
        const cityRes = await dispatch(
          fetchCities([countryCode, stateCode]),
        ).unwrap();
        const cityOptions = cityRes.map((city) => ({
          name: city.label,
          code: city.value,
        }));

        setAddressData((prev) => ({
          ...prev,
          state: value,
          city: null,
          cityOptions,
        }));
      }
    }
    if (name === "city") {
      setAddressData((prev) => ({ ...prev, city: value }));
    }
  };

  const validNumber = (x) => {
    const out = /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/.test(x || "");
    return out;
  };

  useEffect(() => {
    setBtnToggle(true);

    const isValid = !!(
      ((typeof addressData?.country === "object" &&
        addressData?.country.name &&
        addressData?.country?.code) ||
        addressData?.country) &&
      addressData?.type?.trim() &&
      addressData?.address_line_1?.trim() &&
      addressData?.postalcode?.trim() &&
      validNumber(addressData.postalcode)
    );

    setBtnToggle(!isValid);
  }, [addressData, setBtnToggle]);

  const fetchDropdownData = async (addressInfo) => {
    const countryCode =
      typeof addressInfo?.country === "object"
        ? addressInfo?.country.code
        : addressInfo?.country;

    const stateCode =
      typeof addressInfo?.state === "object"
        ? addressInfo?.state.code
        : addressInfo?.state;

    const cityCode =
      typeof addressInfo?.city === "object"
        ? addressInfo?.city.code
        : addressInfo?.city;

    let stateOptions = addressInfo?.stateOptions;
    let cityOptions = addressInfo?.cityOptions;

    if (!stateOptions && countryCode) {
      const stateRes = await dispatch(fetchStates(countryCode)).unwrap();
      stateOptions = stateRes.map((state) => ({
        name: state.label,
        code: state.value,
      }));
    }

    if (!cityOptions && countryCode && stateCode) {
      const cityRes = await dispatch(
        fetchCities([countryCode, stateCode]),
      ).unwrap();
      cityOptions = cityRes.map((city) => ({
        name: city.label,
        code: city.value,
      }));
    }

    const selectedState = stateOptions?.find(
      (state) => state.code === stateCode,
    );
    const selectedCity = cityOptions?.find((city) => city.code === cityCode);

    setAddressData((prev) => ({
      ...prev,
      state: selectedState,
      city: selectedCity,
      stateOptions,
      cityOptions,
    }));
  };

  useEffect(() => {
    if (
      !isNewAddress &&
      !hasFetchedDropdownData.current &&
      addressData?.country
    ) {
      fetchDropdownData(addressData);
      hasFetchedDropdownData.current = true;
    }
  }, [addressData, dispatch, setAddressData, isNewAddress]);

  return (
    <div className="address-heading-container grid">
      {isNewAddress && (
        <div className="text-left shareholder-address">
          <h4 className="address-heading">Address</h4>
          <p className="address-description">
            Enter all the details for this appointment
          </p>
        </div>
      )}
      <div className="text-left">
        <p className="sub-address-heading m-0">
          {type === "Individual" ? "Primary Address" : "Registered Address"}
        </p>
      </div>

      <div className="formgrid grid">
        <AddressFileds
          isEdit={isEdit}
          handleOnchange={handleOnchange}
          data={addressData}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

ShareholderAddress.propTypes = {
  addressData: PropTypes.object,
  setAddressData: PropTypes.func,
  setBtnToggle: PropTypes.func,
  type: PropTypes.string,
};

export default ShareholderAddress;
